type Column = { name: string; label: string; width: number };

export const columns: Column[] = [
  { name: 'linkCreated', label: 'Link Created', width: 215 },
  { name: 'resultsReceived', label: 'Results Received', width: 215 },
  { name: 'expirationDate', label: 'Expiration Date', width: 215 },
  { name: 'result', label: 'Result', width: 165 }
];

export const getColumns = (isIncomplete: boolean): Column[] => {
  if (isIncomplete) {
    const selectedNames = ['linkCreated', 'resultsReceived', 'result'];
    const selectedColumns = columns.filter((c) => selectedNames.includes(c.name));
    return [...selectedColumns, { name: 'reason', label: 'Reason', width: 215 }];
  }
  return columns;
};
